<template>
  <div class="widget--datatable">
    <vxe-table
      ref="table"
      class="main-table"
      size="mini"
      border
      show-header-overflow
      show-overflow
      highlight-hover-row
      :empty-text="$t('label.no_data_found')"
      @cell-click="clickedCell"
      :key="new Date().getTime()"
      :resizable="true"
      :data="tableData">

      <vxe-table-column
        v-for="(field) in fields" :key="field.key"
        :field="field.key"
        :title="field.key"
        :class-name="shouldHighlight"
        :width="field.width"
      >
        <template v-slot:header="{ columnIndex }">
          <div class="header-wrap">
            <div class="name">
              {{ tran(unikey, field.key) }}
            </div>
          </div>
        </template>
        <template v-slot="{ row }">
          <div>{{ row[field.key] }}</div>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div class="footer">
        <div class="result">
          {{ $tc("label.total_record_desc", setting.pagination.max > 0 ? 2 : 1, { row: setting.pagination.item, page: setting.pagination.current, max_page: setting.pagination.max }) }}
        </div>
        <div class="pagination">
          <el-pagination
            background
            @current-change="changePage"
            :current-page.sync="setting.pagination.current"
            :page-size="1"
            layout="jumper, prev, pager, next"
            :total="setting.pagination.max">
          </el-pagination>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    unikey: String,
    tableData: {
      type: Array
    },
    fields: {
      type: Array
    },
    setting: {
      type: Object,
      default() {
        return {
          pagination: {
            perPage: 5,
            total: 0,
            current: 1,
            item: 0,
            max: 0
          },
          sort: {
            field: "",
            order: ""
          },
        }
      }
    }
  },
  methods: {
    shouldHighlight({ rowIndex }) {
      if(rowIndex == this.selected_row) {
        return "row-clicked";
      }
    },
    clickedCell({ rowIndex }) {
      this.selected_row = rowIndex;
    },
    changePage(page) {
      this.selected_row = -1;
      // this.pagination.current = page;
      this.$emit("changePage", page);
    },
  },
  data() {
    return {
      selected: 0,
      selected_row: -1,
      
    }
  }
}
</script>

<style lang="scss">
.widget--datatable{
  .footer{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .result{
      font-size: small;
    }
    .pagination{
      display: flex;
      margin-top: 10px;
      justify-content: flex-end;
      .page{
        font-size: x-small;
        cursor: pointer;
        user-select: none;
        width: 25px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #c5e1ff;
        border-color: #c5e1ff;
        color: white;
        &:not(:last-child) {
          margin-right: 10px;
        }
        &.current{
          background-color: #409EFF;
          border-color: #409EFF;
        }
      }
    }
  }
}
</style>